import Form from "../../../../../form";
import { genericGet, genericPost } from "../../../../../services/api.service";
import { ExpedicoesConfig } from "../../../../Peças/Expedicoes/Expedicoes.config";
import { toast } from 'react-hot-toast';
import { useFormType } from "../../../../../form/hooks/useForm";
import { useContext } from "react";
import { FactoryFloorContext } from "../../../../../contexts/FactoryFloorContext";


const toastDuration = 3000;

type ExpedicaoOperacaoExternaFormType = {
    setExpeditionIndex: any,
    operacao: any,
    pecaEntregaId: number,
    form: useFormType,
    setPecasToDisplay: any
}


export function ExpedicaoOperacaoExternaForm({setExpeditionIndex, operacao, pecaEntregaId, form, setPecasToDisplay } : ExpedicaoOperacaoExternaFormType) {

    const {selectionValues} = useContext(FactoryFloorContext);

    const submitExpedicao = async (operacaoId: number, entregaId: number) => {
        console.log("Will make expedition for operation: ", operacaoId);
        await toast.promise(
            (async () => {
                await genericPost(`/pecas/entregas/${entregaId}/operacao/${operacaoId}/expedicao-operacao`)(form.state);
                const updatedPecas = await genericGet(`/obras/${selectionValues.obra?.id}/entregas/${selectionValues.entrega?.id}/operacoes/${selectionValues.operacao}`)
                setPecasToDisplay(updatedPecas);
                setExpeditionIndex(-1);

            })()
            , {
                success: (t: any) => (
                    <span>
                        <span>Expedição criada com sucesso!!</span>
                    </span>
                ),
                error: ({ response }: any) => (
                    <span>
                        <span>Erro ao criar entidade Expedição <p>{response.data.error}</p></span>
                    </span>
                ),
                duration: toastDuration
            } as any
        )
    }


    return (<Form
        onCancel={() => setExpeditionIndex(-1)}
        submitData={() => submitExpedicao(operacao.id, pecaEntregaId)}
        idProp={"reference"}
        entityName={"Expedição para operação"}
        isNewEntity 
        buildGetterFunction={() => null}
        tableConfigs={ExpedicoesConfig}
        form={form} />)


}